// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "8422fbde02309a600abbe1ca432d934c",
  base: "https://api.openweathermap.org/data/2.5/",
};
